// Vị trí kho (YC-07 phần 1, 30/10/2026). Tiếng Trung giản thể (luật vàng 8).
export const binsEn = {
 title: 'Warehouse locations',
 intro: 'Location list for each warehouse and the stock sitting at each location. Locations follow your numbering: rack + slot, two slots per level (level 1 = A/B, level 2 = C/D, level 3 = E/F).',
 tabCatalog: 'Location list', tabStock: 'Stock by location',
 warehouse: 'Warehouse', chooseWarehouse: 'Choose a warehouse',
 counts: '{{active}} in use · {{total}} in list',
 notConfigured: 'This warehouse has no location list yet: receipts, transfers and counts still accept any typed location, as before.',
 configured: 'This warehouse uses its location list: receiving, transfers in, opening stock, subcontract receipts and production output must use a listed location.',
 generate: 'Generate locations', fromRack: 'From rack', toRack: 'To rack', levels: 'Levels', zone: 'Zone', zoneHint: 'Optional, e.g. awaiting dispatch or one customer\'s storage',
 preview: '{{count}} locations: {{first}} … {{last}}', generateDone: 'Created {{created}} locations, {{skipped}} already existed.',
 addOne: 'Add one location', code: 'Location code', codeHint: 'For areas outside the rack rule, e.g. STAGING', add: 'Add',
 zoneRange: 'Set zone for a rack range', applyZone: 'Apply zone', zoneDone: 'Zone set on {{count}} locations.',
 search: 'Search location or zone', allZones: 'All zones',
 colCode: 'Location', colRack: 'Rack', colLevel: 'Level', colZone: 'Zone', colStock: 'Stock lines', colStatus: 'Status', colActions: 'Actions',
 active: 'In use', inactive: 'Not in use', deactivate: 'Stop using', activate: 'Use again', remove: 'Delete', removeConfirm: 'Delete location {{code}}? It has no stock; the record is kept in Deleted records.', editZone: 'Zone of {{code}}',
 empty: 'No locations yet. Generate them from the rack rule above.',
 stockIntro: 'Read from the same stock ledger as Warehouse & LOT. A location not in the list (typed before the list existed) is marked so it can be moved to a proper location with a transfer.',
 outsideOnly: 'Only stock outside the location list', allWarehouses: 'All warehouses', stockSearch: 'Search location, product, lot',
 colProduct: 'Product', colLot: 'Lot', colQuantity: 'On hand', colAvailable: 'Usable', colUnit: 'Unit', notInList: 'Not in list',
 stockEmpty: 'No stock matches these filters.',
 error: 'Unable to load or save locations.',
 rulesTitle: 'Rules decided by ERP standard',
 rules: {
  multi: 'One location can hold several products and lots; no capacity limit.',
  zone: 'Zones are free text for viewing and filtering; they do not block putting goods in the "wrong" zone.',
  enforce: 'Only warehouses with a location list are checked; codes are stored upper-case without spaces. Old typed locations are not edited: move the goods with a transfer.',
 },
 errors: {
  unknownLocation: 'Location {{location}} is not in this warehouse\'s location list. Choose a listed location or add it under Warehouse locations.',
  duplicate: 'Location {{code}} already exists in this warehouse.',
  inUse: 'Location {{code}} still has stock. Move the goods out or stop using it instead.',
  invalidCode: 'Location codes use letters, digits, ".", "-", "_" or "/".',
  warehouse: 'Warehouse not found or archived.',
  notFound: 'Location not found. Reload the page.',
 },
};

export const binsVi = {
 title: 'Vị trí kho',
 intro: 'Danh mục vị trí của từng kho và hàng đang nằm ở từng vị trí. Mã vị trí theo cách đánh số của Quý công ty: số kệ + ô, mỗi tầng hai ô (tầng 1 = A/B, tầng 2 = C/D, tầng 3 = E/F).',
 tabCatalog: 'Danh mục vị trí', tabStock: 'Tồn theo vị trí',
 warehouse: 'Kho', chooseWarehouse: 'Chọn kho',
 counts: '{{active}} đang dùng · {{total}} trong danh mục',
 notConfigured: 'Kho này chưa có danh mục vị trí: phiếu nhập, chuyển kho, kiểm kê vẫn nhận vị trí gõ tự do như trước.',
 configured: 'Kho này đã dùng danh mục vị trí: nhập kho, chuyển đến, tồn đầu kỳ, nhận gia công và nhập thành phẩm phải dùng vị trí có trong danh mục.',
 generate: 'Sinh vị trí', fromRack: 'Từ kệ', toRack: 'Đến kệ', levels: 'Số tầng', zone: 'Vùng hàng', zoneHint: 'Không bắt buộc, vd hàng chờ xuất, khu lưu riêng cho một khách',
 preview: '{{count}} vị trí: {{first}} … {{last}}', generateDone: 'Đã tạo {{created}} vị trí, {{skipped}} vị trí đã có từ trước.',
 addOne: 'Thêm một vị trí', code: 'Mã vị trí', codeHint: 'Cho khu không theo quy tắc kệ, vd STAGING', add: 'Thêm',
 zoneRange: 'Gán vùng cho dải kệ', applyZone: 'Gán vùng', zoneDone: 'Đã gán vùng cho {{count}} vị trí.',
 search: 'Tìm vị trí hoặc vùng', allZones: 'Mọi vùng',
 colCode: 'Vị trí', colRack: 'Kệ', colLevel: 'Tầng', colZone: 'Vùng', colStock: 'Dòng tồn', colStatus: 'Trạng thái', colActions: 'Thao tác',
 active: 'Đang dùng', inactive: 'Ngừng dùng', deactivate: 'Ngừng dùng', activate: 'Dùng lại', remove: 'Xoá', removeConfirm: 'Xoá vị trí {{code}}? Vị trí không còn hàng; bản ghi được giữ ở Dữ liệu đã xoá.', editZone: 'Vùng của {{code}}',
 empty: 'Chưa có vị trí nào. Sinh vị trí theo quy tắc kệ ở trên.',
 stockIntro: 'Đọc từ cùng sổ tồn với Kho & LOT. Vị trí ngoài danh mục (gõ tự do trước khi có danh mục) được đánh dấu để chuyển về vị trí chuẩn bằng phiếu chuyển.',
 outsideOnly: 'Chỉ hàng ở vị trí ngoài danh mục', allWarehouses: 'Mọi kho', stockSearch: 'Tìm vị trí, mã hàng, lô',
 colProduct: 'Mã hàng', colLot: 'Lô', colQuantity: 'Tồn', colAvailable: 'Dùng được', colUnit: 'Đơn vị', notInList: 'Ngoài danh mục',
 stockEmpty: 'Không có hàng khớp bộ lọc.',
 error: 'Không tải hoặc lưu được vị trí.',
 rulesTitle: 'Quy tắc chốt theo chuẩn ERP',
 rules: {
  multi: 'Một vị trí chứa được nhiều mã hàng và nhiều lô; không giới hạn sức chứa.',
  zone: 'Vùng hàng là chữ tự do để nhìn và lọc; không chặn cất hàng "sai vùng".',
  enforce: 'Chỉ kiểm ở kho đã có danh mục; mã ghi chữ hoa, không khoảng trắng. Vị trí cũ gõ tự do không bị sửa: chuyển hàng bằng phiếu chuyển.',
 },
 errors: {
  unknownLocation: 'Vị trí {{location}} không có trong danh mục vị trí của kho này. Chọn vị trí có trong danh mục hoặc khai thêm ở Vị trí kho.',
  duplicate: 'Vị trí {{code}} đã có trong kho này.',
  inUse: 'Vị trí {{code}} còn hàng. Chuyển hàng đi hoặc chỉ ngừng dùng.',
  invalidCode: 'Mã vị trí chỉ gồm chữ, số, ".", "-", "_" hoặc "/".',
  warehouse: 'Không tìm thấy kho hoặc kho đã lưu trữ.',
  notFound: 'Không tìm thấy vị trí. Tải lại trang.',
 },
};

export const binsZh = {
 title: '库位',
 intro: '每个仓库的库位清单，以及每个库位上的库存。库位编码按贵司的编号方式：货架号 + 格位，每层两格（第1层 = A/B，第2层 = C/D，第3层 = E/F）。',
 tabCatalog: '库位清单', tabStock: '按库位库存',
 warehouse: '仓库', chooseWarehouse: '选择仓库',
 counts: '使用中 {{active}} · 清单中 {{total}}',
 notConfigured: '此仓库尚未建立库位清单：入库、调拨、盘点仍可像以前一样手动输入库位。',
 configured: '此仓库已使用库位清单：入库、调入、期初库存、委外收货和生产入库必须使用清单中的库位。',
 generate: '生成库位', fromRack: '起始货架', toRack: '结束货架', levels: '层数', zone: '货品区域', zoneHint: '可选，例如待出货区、某客户专存区',
 preview: '{{count}} 个库位：{{first}} … {{last}}', generateDone: '已新建 {{created}} 个库位，{{skipped}} 个已存在。',
 addOne: '添加单个库位', code: '库位编码', codeHint: '用于不按货架规则编号的区域，例如 STAGING', add: '添加',
 zoneRange: '为货架范围设置区域', applyZone: '设置区域', zoneDone: '已为 {{count}} 个库位设置区域。',
 search: '搜索库位或区域', allZones: '全部区域',
 colCode: '库位', colRack: '货架', colLevel: '层', colZone: '区域', colStock: '库存行', colStatus: '状态', colActions: '操作',
 active: '使用中', inactive: '已停用', deactivate: '停用', activate: '重新启用', remove: '删除', removeConfirm: '删除库位 {{code}}？该库位没有库存；记录保留在已删除数据中。', editZone: '{{code}} 的区域',
 empty: '还没有库位。请按上方货架规则生成。',
 stockIntro: '与“仓库与批次”读取同一库存账。不在清单中的库位（建立清单前手动输入的）会被标记，以便用调拨单移到标准库位。',
 outsideOnly: '只看清单外库位的库存', allWarehouses: '全部仓库', stockSearch: '搜索库位、货号、批次',
 colProduct: '货号', colLot: '批次', colQuantity: '库存', colAvailable: '可用', colUnit: '单位', notInList: '清单外',
 stockEmpty: '没有符合筛选条件的库存。',
 error: '无法加载或保存库位。',
 rulesTitle: '按ERP标准确定的规则',
 rules: {
  multi: '一个库位可存放多个货号和多个批次；不限制容量。',
  zone: '货品区域是自由文字，用于查看和筛选；不阻止放到“错误”区域。',
  enforce: '只检查已建立清单的仓库；编码统一为大写、无空格。以前手动输入的库位不会被修改：请用调拨单移库。',
 },
 errors: {
  unknownLocation: '库位 {{location}} 不在此仓库的库位清单中。请选择清单中的库位，或在“库位”中添加。',
  duplicate: '此仓库已有库位 {{code}}。',
  inUse: '库位 {{code}} 仍有库存。请先移出货品，或改为停用。',
  invalidCode: '库位编码只能包含字母、数字、“.”、“-”、“_”或“/”。',
  warehouse: '找不到仓库或仓库已归档。',
  notFound: '找不到库位，请刷新页面。',
 },
};
